import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export const usePageDetails = () => {
  const [id, setId] = useState<string | null>(null);
  const [pageType, setPageType] = useState<"create" | "edit" | "view">(
    "create",
  );
  const { type } = useParams();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const pageId = searchParams.get("id");

    setId(pageId);

    if (type === "edit") {
      setPageType("edit");
    } else if (type === "create" && pageId) {
      setPageType("view");
    } else {
      setPageType("create");
    }
  }, [type, id]);

  return { id, pageType };
};
